import { defineComponent } from "@vue/composition-api";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
export default defineComponent({
  name: "DeleteElementIcon",
  components: {
    InlinePrompt
  },
  setup() {}
});